module.exports = __webpack_public_path__ + "static/media/RP-B_C_Embroidery_Bicocca_White_IndBlue.9adcfa58.png";